// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2yMAm","col":"styles_col__1Sdk5","fulfillmentStatus":"styles_fulfillmentStatus__F1MMK","emailCol":"styles_emailCol__3n0Od"};